import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'
import styled, { css } from 'styled-components'

import { Link } from '@utils/cook/types'

import Footer from '../Footer'
import Header from '../Header'
import Numbers from '../Numbers'
import { SwisslottoData } from '../types'

interface SwisslottoProps {
  data: SwisslottoData
  link: Link
}

const Table = dynamic(() => import('../Table'))

const StyledSwisslotto = styled.div`
  ${({
    theme: {
      colors: { fillWeak },
      spacing: { spacing20 },
    },
  }) => css`
    padding: ${spacing20} ${spacing20} 15px ${spacing20};
    background-color: ${fillWeak};
  `}
`

const Swisslotto: FunctionComponent<SwisslottoProps> = ({ data, link }) => {
  const {
    numbers,
    luckynumber,
    'replay-number': replayNumber,
    'formatted-jackpot': jackpot,
    'next-draw-date': nextDate,
    'draw-date': drawDate,
  } = data
  return (
    <StyledSwisslotto>
      <Header title="Swiss Lotto" drawDate={drawDate} id="swisslotto" />
      <Numbers
        numbers={numbers}
        luckyNumber={luckynumber}
        replayNumber={replayNumber}
      />
      <Table lottoData={data} id="swisslotto" />
      <Footer link={link} jackpot={jackpot} nextDate={nextDate} />
    </StyledSwisslotto>
  )
}

export default Swisslotto
